<div
  class="flex w-full h-full bg-green-400 p-1"
  appPosition [position]="
  {
    top: component().properties.position.y,
    left: component().properties.position.x
   }"
  [ngStyle]="{
        'fontSize.px': component().properties.fontSize,
        'background-color':component().properties.background ?? 'gray',
        'color': component().properties.colorText,
        'width.px':component().properties.size.width ,
        'height.px':component().properties.size.height ,
        }"
>
  <lib-slider [slides]="component().properties.itemCarousel ?? []"></lib-slider>
</div>
